import { InjectionToken } from '@angular/core';

export const StorageService: InjectionToken<Storage> = new InjectionToken<Storage>('StorageService');
export const LocalStorageService: InjectionToken<Storage> = new InjectionToken<Storage>('LocalStorageService');
export const SessionStorageService: InjectionToken<Storage> = new InjectionToken<Storage>('SessionStorageService');
